import { render, staticRenderFns } from "./EntitySettings.vue?vue&type=template&id=a9affdca&scoped=true"
import script from "./EntitySettings.vue?vue&type=script&lang=js"
export * from "./EntitySettings.vue?vue&type=script&lang=js"
import style0 from "./EntitySettings.vue?vue&type=style&index=0&id=a9affdca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9affdca",
  null
  
)

export default component.exports